import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import * as _ from "underscore";
import { Configuration } from 'config/config';
//import * as $ from 'jquery/dist/jquery.min.js';

@Injectable()
export class AppUtils {

  public static getError(response): string {
    let errorMessage = "Please try again!";
    if (!AppUtils.isUndefinedOrNull(response) && !AppUtils.isUndefinedOrNull(response.message)) {
      errorMessage = response.message;
      if (!AppUtils.isUndefinedOrNull(response.submessage)) {
        errorMessage = response.submessage + (response.submessage.endsWith(".") ? " " : ". ") + errorMessage;
      }
    }

    return errorMessage;
  }

  public static isUndefined(value): boolean {
    return _.isUndefined(value);
  }

  public static isUndefinedOrNull(value): boolean {
    return (_.isUndefined(value) || _.isNull(value) || value.length === 0 || _.isEmpty(value));
  }

      // setting img paths

      setImagesPath(company, branch) {
        // path images
        localStorage.setItem('cnicImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/cnic/');
        // localStorage.setItem('covidImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/covid/');
        localStorage.setItem('feereceiptImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/feereceipts/');
        localStorage.setItem('memberImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/members/');
        localStorage.setItem('assetImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/assets/');
        localStorage.setItem('employeeImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/employees/');
        localStorage.setItem('userImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/users/');
        localStorage.setItem('trainerImagePath', 'assets/layout/images/company_' + company + '/branch_' + branch + '/trainers/');
        localStorage.setItem('companyImagePath', 'assets/layout/images/companies/');

        const configurations = new Configuration();

        configurations.cnicImagePath = localStorage.getItem('cnicImagePath');
        // configurations.covidImagePath = localStorage.getItem('covidImagePath');
        configurations.feereceiptImagePath = localStorage.getItem('feereceiptImagePath');
        configurations.assetImagePath = localStorage.getItem('assetImagePath');
        configurations.memberImagePath = localStorage.getItem('memberImagePath');
        configurations.employeeImagePath = localStorage.getItem('employeeImagePath');
        configurations.userImagePath = localStorage.getItem('userImagePath');
        configurations.trainerImagePath = localStorage.getItem('trainerImagePath');
        configurations.companyImagePath = localStorage.getItem('companyImagePath');


    }

  public static markAsDirty(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsDirty();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsDirty(<UntypedFormGroup>group.controls[i]);
      }
    }
  }
  public static markAsUntouch(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsUntouched();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsUntouch(<UntypedFormGroup>group.controls[i]);
      }
    }
  } public static markAsTouch(group: UntypedFormGroup) {
    group.markAsDirty();
    for (const i in group.controls) {
      if (group.controls[i] instanceof UntypedFormControl) {
        group.controls[i].markAsTouched();
      } else if (group.controls[i] instanceof UntypedFormGroup) {
        AppUtils.markAsTouch(<UntypedFormGroup>group.controls[i]);
      }
    }
  }

  public static deepCopy(to: Array<any>, from: Array<any>) {

    for (let i = 0; i < to.length; i++) {
      to.pop();
    }
    to.pop();
    for (let i = 0; i < from.length; i++) {
      to.push(from[i]);
    }
  }

  public static copyDataInForm(data, form) {
    Object.keys(data).forEach(name => {
      if (form.controls[name]) {
        form.controls[name].patchValue(data[name]);
      }
    });
  }

  public static enableForm(group: UntypedFormGroup, enable: boolean) {
    for (const i in group.controls) {
      if (enable) {
        group.controls[i].enable();
      } else {
        group.controls[i].disable();
      }
    }
  }

  public static copyObjectFields(newObject, oldObject) {
    Object.keys(newObject).forEach(name => {
      if (oldObject[name] || oldObject[name] == null) {
        oldObject[name] = newObject[name];
      }
    });
  }

  public static contains(criteriaName: string, array: any): boolean {
    let exists = false;

    if (!AppUtils.isUndefinedOrNull(array)) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === criteriaName) {
          exists = true;
          break;
        }
      }
    }

    return exists;
  }

  public static convertBytesInMB(sizeInBytes: number): number {
    return ((sizeInBytes / 1024) / 1024);
  }

  public static addAlphabaticsChars(charArray) {
    for (let i = 65; i <= 90; i++) {
      charArray.push(String.fromCharCode(i));
    }
  }

  public static convertArrayIntoString(array: string[]): string {
    let str = "";
    const delimeter = ", ";

    for (let i = 0; i < array.length; i++) {
      if (i === (array.length - 1)) {
        str += array[i];
      } else {
        str += array[i] + delimeter;
      }
    }

    return str;
  }

  // public static scrollToElement(element: string, delay: number = 50) {
  //   setTimeout(() => {
  //     $('html, body').animate({
  //       scrollTop: $(element).offset().top - 80
  //     }, 500);
  //   }, delay);

  // }

  public static getFileExtension(fileName: string, addDot: boolean): string {
    return (addDot ? "." : "") + fileName.split('.').pop();
  }

  public static getPercent(value, totalInSeconds: any) {
    return ((value / totalInSeconds) * 100);
  }

  public static getPercentRoundedOf(value, totalInSeconds: any) {
    return ((value / totalInSeconds) * 100).toFixed(2);
  }

  public static deepCloneObject(objectToCopy) {
    return (JSON.parse(JSON.stringify(objectToCopy)));
  }

  public static getCurrentURI(): string {
    return window.location.href;
  }
  public static getMonthName(month: number) {
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];
    return months[month -1];
}
  public static generateInvoiceNo(membershipNoOrVisitorName, feeDetails, currentYear, currentMonth, isVisitor = false, counterCheck = 1) {

    let invoice;
    let counter = 1;
    let visitorMonth;
    let visitorYear;
    let memberMonth;
    let memberYear;
    if (isVisitor == false) {
      let sortedFiltered = feeDetails
        .filter(result => {
          const date = new Date(result.date);
          memberMonth = date.getMonth() + 1;
          memberYear = date.getFullYear();
          return memberMonth == currentMonth && memberYear == currentYear;
        }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      if (sortedFiltered.length > 0 && sortedFiltered[0].invoice) {
        let splitedArray = sortedFiltered[0].invoice.trim().split('-');
        if (splitedArray.length > 4) {
          counter = Number(splitedArray[4]) + counterCheck;
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        } else {
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        }
      } else {
        invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counterCheck}`;
      }
      return invoice;
    } else {
      let sortedFiltered = feeDetails
        .filter(result => {
          const date = new Date(result.date);
          visitorMonth = date.getMonth() + 1;
          visitorYear = date.getFullYear()
          return visitorMonth == currentMonth && visitorYear == currentYear;
        }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      if (sortedFiltered.length > 0 && sortedFiltered[0].invoice) {
        let splitedArray = sortedFiltered[0].invoice.trim().split('-');
        if (splitedArray.length > 4) {
          counter = Number(splitedArray[4]) + 1;
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        } else {
          invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
        }
      } else {
        invoice = `Inv#-${membershipNoOrVisitorName}-${currentYear}-${currentMonth}-${counter}`;
      }
      return invoice;
    }
  }
  public static base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
        ;
    }
    return new File([u8arr], filename, { type: mime });
  }
}
